import React from "react";
import BaseComponent from "../BaseComponent";
import Input from "../Input";
import Dropdown from "../Dropdown";
import Button from "../Button";

export default class SetValSubCon extends BaseComponent {
    /**
     * Submenu view for variable writer node
     * @module SetValSubCon
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.varModel = (this.props.data && this.props.data.keyValue) ? this.props.data.keyValue : this.initVarModel();
        this.varIdx = (this.props.data && this.props.data.varIdx) ? this.props.data.varIdx : 0;
    }

    /**
     * Initialize dummy data model
     * @returns {Object}
     */
    initVarModel() {
        return {
            value: null,
            variable: null
        };
    }

    /**
     * Set config proxy; catches own input value updates and update its data model before saving to list
     * @param {string} key
     * @param {string} value
     */
    setConfig(key, value) {
        this.varModel[key] = value;
    }

    /**
     * React render
     * @returns {XML}
     */
    render() {
        return (
            <div>
                {<Input label={this.getPropLabel("value")} hint={this.getPropLabel("value")}
                        context={this} valKey={"value"} value={this.varModel["value"]}/>}
                {<Dropdown context={this} label={this.getPropLabel("variable")} optionName={this.getPropLabel("select_variable")}
                           options={this.props.params["options"]} valKey={"variable"}/>}
                {(() => {
                    return (
                        <Button label={this.getPropLabel("add")} wide={true}
                                callback={() => {
                                    if (this.varModel && this.varModel.value) {
                                        // Add current data model to item list
                                        this.props.context.add(this.varModel);
                                    }
                                    this.varModel = this.initVarModel();
                                    this.props.domContext.removeSubmenu();
                                }}
                        />
                    );
                })()}
            </div>
        );
    }
}